export default "__VITE_ASSET__6227b3ba__"